import { render, staticRenderFns } from "./ckModel.vue?vue&type=template&id=299f5aec&scoped=true&"
import script from "./ckModel.vue?vue&type=script&lang=js&"
export * from "./ckModel.vue?vue&type=script&lang=js&"
import style0 from "./ckModel.vue?vue&type=style&index=0&id=299f5aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f5aec",
  null
  
)

export default component.exports